// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ls-0";